import { Request } from './Request';

export interface IGetZiplogUriParams {
}

export interface IGetZiplogUriResult {
  data: string; // the uri
}

export class GetZiplogUriRequest extends Request<IGetZiplogUriParams, IGetZiplogUriResult> {
  constructor(params: IGetZiplogUriParams = {}) {
    super('getZiplogUri', params);
  }
}
